/**
 * CountBadge tones — colour intent. The `accent` tone is theme-aware
 * inside the atom (light themes get the `primaryContainer` pair;
 * dark themes get a primary-tinted surface) so the consumer doesn't
 * have to branch on theme to keep contrast acceptable.
 */
export const COUNT_BADGE_TONE_NEUTRAL = 'neutral';
export const COUNT_BADGE_TONE_ERROR = 'error';
export const COUNT_BADGE_TONE_ACCENT = 'accent';

export type CountBadgeTone =
  | typeof COUNT_BADGE_TONE_NEUTRAL
  | typeof COUNT_BADGE_TONE_ERROR
  | typeof COUNT_BADGE_TONE_ACCENT;

/**
 * CountBadge sizes — pick by surrounding density:
 * - `xs`: SegmentedControl-style chip badge (11px sans, 0 5px padding,
 *   no minimum dimensions). Sits flush against a label inside a chip.
 * - `sm` (default): tab-style badge (10.5px mono, 18×18 min, 0 6px
 *   padding). Reads as a "count" affordance next to a tab label.
 */
export const COUNT_BADGE_SIZE_XS = 'xs';
export const COUNT_BADGE_SIZE_SM = 'sm';

export type CountBadgeSize =
  | typeof COUNT_BADGE_SIZE_XS
  | typeof COUNT_BADGE_SIZE_SM;

interface CountBadgeSizeTokens {
  fontSize: string;
  fontWeight: number;
  padX: string;
  minDim: string | null;
  mono: boolean;
}

export const COUNT_BADGE_SIZE_TOKENS: Record<
  CountBadgeSize,
  CountBadgeSizeTokens
> = {
  [COUNT_BADGE_SIZE_XS]: {
    fontSize: '11px',
    fontWeight: 500,
    padX: '5px',
    minDim: null,
    mono: false,
  },
  [COUNT_BADGE_SIZE_SM]: {
    fontSize: '10.5px',
    fontWeight: 600,
    padX: '6px',
    minDim: '18px',
    mono: true,
  },
};
